import type { OfflineActivityType } from '../utils/offlineQueue'

export const DB_TABLES = {
  operacoes: 'operacoes',
  checklists: 'checklists',
  auditorias: 'auditorias',
  relatoriosMapa: 'relatorios_mapa',
} as const

export type DbTableName = typeof DB_TABLES[keyof typeof DB_TABLES]

export const OFFLINE_ACTIVITY_TABLE: Record<OfflineActivityType, DbTableName> = {
  operacao: 'operacoes',
  checklist: 'checklists',
  auditoria: 'auditorias',
  relatorio: 'relatorios_mapa',

  operacao_update: 'operacoes',
  checklist_update: 'checklists',
  auditoria_update: 'auditorias',
  relatorio_update: 'relatorios_mapa',

  evidencia_operacional: 'operacoes',
  evento_operacao: 'operacoes',
  historico_operacional: 'operacoes',

  ordem_servico: 'operacoes',
  tarefa_operacional: 'operacoes',

  ordem_servico_update: 'operacoes',
  tarefa_operacional_update: 'operacoes',
}

export function isOfflineUpdate(type: OfflineActivityType) {
  return type.endsWith('_update')
}

export function hasOfflineAttachments(type: OfflineActivityType) {
  return type === 'operacao' || type === 'auditoria'
}


